/* MerrySend -> HubSpot form bridge
   Mirrors existing theme form data into HubSpot Forms API on submit.
   Never alters, blocks or restyles a form. Fails silently by design:
   if HubSpot is unreachable the customer's submission still goes through.
   Internal HubSpot property names keep the original sendetto_* prefix;
   only customer-visible values carry the MerrySend name.

   Form GUIDs: portal 244181426, region na2. All four forms were rebuilt
   on 14 September 2026 after the rename and verified field-by-field
   against what each function below posts — the Forms API rejects the
   whole submission if it contains a field the form does not define, so
   any new field added here must be added to the form as well. Every
   value is sent explicitly, so a missing default on the HubSpot form
   never loses data. */
(function () {
  var PORTAL = '244181426';
  var BRAND = 'MerrySend';
  var F = {
    quote:      'f6458b2d-5270-4e2a-837b-38ec25e34747',  /* MerrySend - Gift quote request  (18 fields) */
    program:    'd7f0f8fe-c84e-4709-b5e2-604d41802d9d',  /* MerrySend - Recognition program (14 fields) */
    brief:      '0b3a7dc8-8697-44e5-be51-d5e94881de57',  /* MerrySend - Homepage brief      (9 fields)  */
    newsletter: 'e7863a6b-5767-4f06-9e3e-264c418309e7'   /* MerrySend - Seasonal edit list  (3 fields)  */
  };

  function num(s) {
    if (s === null || s === undefined) return '';
    var m = String(s).replace(/[^0-9.\-]/g, '');
    if (m === '' || isNaN(parseFloat(m))) return '';
    return String(Math.round(parseFloat(m)));
  }
  function txt(el) { return el ? (el.textContent || '').trim() : ''; }
  function val(form, name) {
    var el = form.querySelector('[name="contact[' + name + ']"]');
    return el ? String(el.value || '').trim() : '';
  }
  function split(full) {
    var p = String(full || '').trim().split(/\s+/);
    return { first: p[0] || '', last: p.slice(1).join(' ') };
  }
  function send(guid, fields) {
    if (!guid) return;
    var clean = [];
    for (var i = 0; i < fields.length; i++) {
      var f = fields[i];
      if (f && f.value !== '' && f.value !== null && f.value !== undefined) clean.push(f);
    }
    if (!clean.length) return;
    try {
      fetch('https://api.hsforms.com/submissions/v3/integration/submit/' + PORTAL + '/' + guid, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        keepalive: true,
        body: JSON.stringify({
          fields: clean,
          context: { pageUri: location.href, pageName: document.title }
        })
      })['catch'](function () {});
    } catch (e) {}
  }

  /* ---------- 1. Homepage gift brief ---------- */
  function brief(form) {
    var root = form;
    var g = function (id) { return root.querySelector('[id^="' + id + '"]'); };
    var qty = g('gb-n'), bud = g('gb-b');
    var n = qty ? num(qty.value) : '';
    var b = bud ? num(bud.value) : '';
    var total = (n && b) ? String(Number(n) * Number(b)) : '';
    var aud = g('gb-a');
    var msg = val(form, 'body');
    var code = val(form, 'partner_code');
    if (aud && aud.value) msg = 'Recipients are ' + aud.value + '.\n' + msg;
    if (code) msg = msg + '\n\nPartner code: ' + code;

    send(F.brief, [
      { name: 'email',                     value: val(form, 'email') },
      { name: 'message',                   value: msg },
      { name: 'sendetto_recipients',       value: n },
      { name: 'sendetto_budget_per_person', value: b },
      { name: 'sendetto_occasion',         value: g('gb-o') ? g('gb-o').value : '' },
      { name: 'sendetto_needed_by',        value: g('gb-t') ? g('gb-t').value : '' },
      { name: 'sendetto_estimate_total',   value: total },
      { name: 'sendetto_request_type',     value: 'Homepage brief' },
      { name: 'business_line',             value: BRAND }
    ]);
  }

  /* ---------- 2. Quote builder / quote basket ---------- */
  function quote(form) {
    var scope = form.closest('.snd-qb-root') || form.closest('section') || document;
    var qty  = scope.querySelector('[id^="qb-qty-"]') || scope.querySelector('[id^="ql-qty-"]');
    var tier = scope.querySelector('[id^="qb-tier-"]');
    var tot  = scope.querySelector('[data-v="total"]');
    var eng  = scope.querySelector('[id^="qb-eng-"]') || scope.querySelector('[id^="ql-eng-"]');
    var card = scope.querySelector('[id^="qb-card-"]') || scope.querySelector('[id^="ql-card-"]');
    var box  = scope.querySelector('[id^="qb-box-"]') || scope.querySelector('[id^="ql-box-"]');

    var opts = [];
    if (eng && eng.checked) opts.push('Engraving');
    if (card && card.checked) opts.push('Greeting card');
    if (box && box.checked) opts.push(BRAND + ' gift box');

    var nm = split(val(form, 'name'));
    var msg = val(form, 'body');
    var cardMsg = val(form, 'card_message');
    if (cardMsg) msg = msg + '\n\nCard message: ' + cardMsg;

    send(F.quote, [
      { name: 'email',                      value: val(form, 'email') },
      { name: 'firstname',                  value: nm.first },
      { name: 'lastname',                   value: nm.last },
      { name: 'company',                    value: val(form, 'company') },
      { name: 'phone',                      value: val(form, 'phone') },
      { name: 'message',                    value: msg },
      { name: 'sendetto_occasion',          value: val(form, 'occasion') },
      { name: 'sendetto_needed_by',         value: val(form, 'needed_by') },
      { name: 'sendetto_ship_to',           value: val(form, 'ship_to') },
      { name: 'sendetto_recipients',        value: qty ? num(qty.value) : '' },
      { name: 'sendetto_budget_per_person', value: tier ? num(tier.value) : '' },
      { name: 'sendetto_estimate_total',    value: num(txt(tot)) },
      { name: 'sendetto_options',           value: opts.join(', ') },
      { name: 'sendetto_estimate_summary',  value: val(form, 'estimate') },
      { name: 'sendetto_charity_choice',    value: val(form, 'charity') },
      { name: 'sendetto_charity_match',     value: val(form, 'charity_match') },
      { name: 'sendetto_request_type',      value: 'Gift quote' },
      { name: 'business_line',              value: BRAND }
    ]);
  }

  /* ---------- 3. Recognition program designer ---------- */
  function program(form) {
    var scope = form.closest('[data-snd]') || form.closest('section') || document;
    var tot = scope.querySelector('.snd-pf-est [data-v="total"]');
    var qtys = scope.querySelectorAll('.snd-pf-qty');
    var awards = 0;
    for (var i = 0; i < qtys.length; i++) {
      var v = parseInt(qtys[i].value, 10);
      if (!isNaN(v) && v > 0) awards += v;
    }

    /* Two questions have no HubSpot property yet, so fold them into the
       summary rather than lose them: program types and HR-date readiness. */
    var picked = [];
    if (form.querySelector('[name="contact[program_milestones]"]:checked')) picked.push('Service milestones');
    if (form.querySelector('[name="contact[program_performance]"]:checked')) picked.push('Performance and incentives');
    if (form.querySelector('[name="contact[program_onboarding]"]:checked')) picked.push('Welcome and onboarding');

    var summary = val(form, 'structure');
    if (picked.length) summary += '\n\nPrograms of interest: ' + picked.join(', ');
    var hr = val(form, 'hr_dates');
    if (hr) summary += '\nHire dates in an HR system: ' + hr;

    var nm = split(val(form, 'name'));

    send(F.program, [
      { name: 'email',                     value: val(form, 'email') },
      { name: 'firstname',                 value: nm.first },
      { name: 'lastname',                  value: nm.last },
      { name: 'company',                   value: val(form, 'company') },
      { name: 'phone',                     value: val(form, 'phone') },
      { name: 'message',                   value: val(form, 'body') },
      { name: 'sendetto_headcount',        value: val(form, 'headcount') },
      { name: 'sendetto_program_start',    value: val(form, 'start') },
      { name: 'sendetto_ship_to',          value: val(form, 'ship_to') },
      { name: 'sendetto_recipients',       value: awards ? String(awards) : '' },
      { name: 'sendetto_estimate_total',   value: num(txt(tot)) },
      { name: 'sendetto_estimate_summary', value: summary },
      { name: 'sendetto_request_type',     value: 'Recognition program' },
      { name: 'business_line',             value: BRAND }
    ]);
  }

  /* ---------- 4. Seasonal edit sign-up (footer + homepage) ---------- */
  function newsletter(form) {
    send(F.newsletter, [
      { name: 'email',                 value: val(form, 'email') },
      { name: 'sendetto_request_type', value: 'Seasonal edit list' },
      { name: 'business_line',         value: BRAND }
    ]);
  }

  /* ---------- routing ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    try {
      if (form.id === 'snd-gb-form') { brief(form); return; }
      if (form.querySelector('[name="contact[structure]"]')) { program(form); return; }
      if (form.querySelector('[name="contact[estimate]"]')) { quote(form); return; }
      var tags = form.querySelector('[name="contact[tags]"]');
      if (tags && /newsletter/i.test(tags.value || '')) { newsletter(form); return; }
    } catch (err) {
      /* never block the customer's submission */
    }
  }, true);
})();
